import {
  del,
  get, post, put,
} from '@/utils/request';

const url = 'card-ticket-types';

export function index(data) {
  return get({
    url,
    data,
  });
}

export function show(id) {
  return get({
    url: `${url}/${id}`,
  });
}

export function getDetailByCardChargeTypeId(id) {
  return get({
    url: `${url}/details`,
    data: { card_charge_type_id: id },
  });
}

export function store(data) {
  return post({
    url,
    data,
  });
}

export function restore(id, update_time) {
  return post({
    url: `${url}/${id}`,
    data: { update_time },
  });
}

export function update(id, data) {
  return put({
    url: `${url}/${id}`,
    data,
  });
}

export function destroy(id, update_time) {
  return del({
    url: `${url}/${id}`,
    data: { update_time },
  });
}
